import * as React from "react"
import { Box } from "@mui/material"

import { ActionButton } from "../../@components"
import { useAdminNewListedForm } from "../../../../@hooks"
import { adminNewListedFormIsSkuMappingData } from "../../../../@signals"


export default function EditButton({ rowData, isSkuMappingTable }) {
    const { handleOpenForm, isOpenEditDrawer, isLoadingDrawer } = useAdminNewListedForm(rowData)

    return <Box componet="span" className={isOpenEditDrawer ? 'is-open' : ''}>
        <ActionButton
            isLoading={isLoadingDrawer}
            label="Edit"
            icon="pen-to-square"
            onClick={() => {
                adminNewListedFormIsSkuMappingData.value = isSkuMappingTable
                handleOpenForm()
            }}
        />
    </Box>
}